import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  acceptRequest,
  addToJourney,
  getOrderInfo,
  getRequestInfo,
  sendUserNotification,
} from "../../../../utilities";
import { useNavigate } from "react-router-dom";
import { Button, Tooltip } from "@mui/material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import NumbersIcon from "@mui/icons-material/Numbers";
import WorkIcon from "@mui/icons-material/Work";
import HomeIcon from "@mui/icons-material/Home";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import {
  RequestActionShell,
  SectionLabel,
  Field,
  NotesInput,
} from "../../../../components/WindowDoor/Requests/RequestActionUI";

const iconProps = { fontSize: 16 };

const AcceptRequest = () => {
  const { id } = useParams();
  const [data, setData] = useState("");
  const [requestData, setReqData] = useState("");
  const [notes, setNotes] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    getOrderInfo(id, setData);
    getRequestInfo(id, setReqData);
  }, []);

  const handleAccept = () => {
    sendUserNotification(
      requestData?.requestEmail,
      "System",
      `Your Request For Order #${requestData.salesOrder} Has Been Accepted`,
      "Delivery Request Accepted"
    );
    acceptRequest(
      id,
      notes,
      requestData.requestDate.replaceAll("/", "-"),
      requestData.orderID
    );
    addToJourney(
      requestData.requestDate.replaceAll("/", "-"),
      requestData.orderID
    );
    navigate("/windowdoor/admin/requestlist");
  };

  return (
    <RequestActionShell
      title="Accept Request"
      accent="emerald"
      id={id}
      showError={requestData.error}
      footer={
        requestData.requestStatus === 0 ? (
          <Button color="success" variant="contained" onClick={handleAccept}>
            Accept Request
          </Button>
        ) : (
          <Tooltip title="This request was already accepted or rejected. Mistake? Please contact HelpDesk.">
            <span>
              <Button color="success" variant="contained" disabled>
                Accept Request
              </Button>
            </span>
          </Tooltip>
        )
      }
    >
      <div className="space-y-6">
        <div>
          <SectionLabel>Order details</SectionLabel>
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
            <Field
              icon={<PersonOutlineIcon sx={iconProps} />}
              label="Customer"
              value={data.Customer}
            />
            <Field
              icon={<NumbersIcon sx={iconProps} />}
              label="Order Number"
              value={data.OrderNumber}
            />
            <Field
              icon={<WorkIcon sx={iconProps} />}
              label="Job Ref"
              value={data["Job Ref"]}
            />
            <div className="sm:col-span-3">
              <Field
                icon={<HomeIcon sx={iconProps} />}
                label="Deliver To"
                value={data["Deliver To"]}
              />
            </div>
          </div>
        </div>

        <div>
          <SectionLabel>Request information</SectionLabel>
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            <Field
              icon={<PersonOutlineIcon sx={iconProps} />}
              label="Requested by"
              value={requestData?.requestName}
            />
            <Field
              icon={<CalendarMonthIcon sx={iconProps} />}
              label="Date requested"
              value={requestData?.requestDate}
            />
            <div className="sm:col-span-2">
              <Field
                icon={<NoteAltIcon sx={iconProps} />}
                label="Notes"
                value={requestData?.notes ? requestData.notes : "No provided notes"}
              />
            </div>
          </div>
        </div>

        <NotesInput value={notes} onChange={(e) => setNotes(e.target.value)} />
      </div>
    </RequestActionShell>
  );
};

export default AcceptRequest;
